import { Text, View } from '@react-pdf/renderer';
import { checkObjHasValues, formatShortDate } from 'utils';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';

const Experience = ({ styles, data = [], headerTitle, randomString }: any) => {
	return (
		<View style={styles.experienceField}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.rightDetails}>
				{data?.map((res: any, idx: number) => {
					if (checkObjHasValues(res)) {
						return (
							<View
								key={`${idx}-exp-${res?.endDate}-${res?.startDate}`}
								style={styles.experienceRow}
							>
								<View style={styles.listBorder}>
									<View style={styles.listCircle}></View>
								</View>
								<View>
									<Text style={styles.experienceDate}>
										{formatShortDate(res?.startDate)} - {formatShortDate(res?.endDate)}
									</Text>
								</View>
								<View style={styles.experienceContent}>
									<Text style={styles.detailText}>{`${res?.jobTitle} at ${res?.company}`}</Text>
									{res?.rolesDesc && (
										<View style={styles.ListBox}>
											<View style={styles.ListData}>
												<Text style={styles.Listicon}>•</Text>
												<Text style={styles.detailSubText}>
													{parse(sanitizeHtml(res.rolesDesc))}
												</Text>
											</View>
										</View>
									)}
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Experience;
